import React, {useCallback} from 'react';
import { Campaign, useCampaignsNameAndRefQuery } from '../../generated/graphql';
import { useState } from 'react';
import {GraphQlSelect} from "./GraphQlSelect";
import {GraphQlSelectId} from "./GraphQlSelectId";
import { isObject } from '../id-diff-merge';

export const CampaignSelect = (props): JSX.Element => {
    const [searchTerm,setSearchTerm] = useState('');
    const campaignsQuery = useCampaignsNameAndRefQuery({variables:{name_or_reference_like:searchTerm?'%'+searchTerm+'%':''}});
    // eslint-disable-next-line react/prop-types, react/display-name
    const renderOptionString = (el:Campaign)=>{
        if(!isObject(el)) return el;
        return (el.job_reference)+' : '+(el.name);
    }
    const onInputChange=useCallback((newInputValue) => {
        console.log('CSC0',newInputValue);
       setSearchTerm(newInputValue);
    },[setSearchTerm]);
    console.log('CSC1',searchTerm,props.value);
    return props.valueAsId?
        <GraphQlSelectId {...props} queryResult={campaignsQuery} renderOptionString={renderOptionString} setSearchTerm={onInputChange} loading={campaignsQuery.loading}/>:
        <GraphQlSelect {...props} queryResult={campaignsQuery} renderOptionString={renderOptionString} setSearchTerm={onInputChange} loading={campaignsQuery.loading}/>;
}